export default __webpack_public_path__ + "static/media/paytm-logo.48f763fb.svg";